import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup, Box, Fade, FormLabel } from '@mui/material';
import * as Yup from 'yup';
import { EXISTING_CARD_PAYMENT_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { useFormikContext } from 'formik';
import { ExistingCardPaymentMethod } from '@acorn-portal/shared/src/services/api';
import ExistingCard from './ExistingCard';

export interface IExistingCardPaymentFormValues {
	id: string;
}

export const EXISTING_CARD_FORM_INITIAL_VALUES: IExistingCardPaymentFormValues = {
	id: '',
};

export const existingCardFormValidationSchema = Yup.object().shape({
	id: Yup.string().required(EXISTING_CARD_PAYMENT_ERRORS.id),
});

interface Props {
	cards: ExistingCardPaymentMethod[];
}

const DebitCardSelector = ({ cards }: Props) => {
	const formik = useFormikContext<IExistingCardPaymentFormValues>();

	const handleCardSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
		formik.setFieldValue('id', event.currentTarget.value, true);
	};

	return (
		<Fade in>
			<FormControl
				component='fieldset'
				fullWidth
				sx={() => ({
					margin: 'auto',
				})}
				error={formik.touched.id && Boolean(formik.errors.id)}
			>
				<FormLabel
					htmlFor='id'
					sx={() => ({
						mb: 0.5,
						textAlign: 'left',
					})}
				>
					Please select a card
				</FormLabel>
				<Box
					sx={(theme) => ({
						borderWidth: '1px',
						borderStyle: 'solid',
						borderColor: formik.touched.id && Boolean(formik.errors.id) ? theme.palette.error.dark : 'transparent',
						borderRadius: 2,
						m: 0,
					})}
				>
					<RadioGroup id='id' value={formik.values.id} onChange={handleCardSelection}>
						{cards.map((card, index) => (
							<Box
								key={card.id}
								sx={(theme) => ({
									position: 'relative',
									border: `1px solid ${theme.palette.divider}`,
									borderRadius: 2,
									mb: index < cards.length - 1 ? 1 : 0,
									height: '80px',
								})}
							>
								<FormControlLabel
									key={card.id}
									value={card.id}
									control={<Radio />}
									label={<ExistingCard card={card} />}
								/>
							</Box>
						))}
					</RadioGroup>
				</Box>
			</FormControl>
		</Fade>
	);
};

export default DebitCardSelector;
